// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"preOnBoarding_imageWrapper__3jlIo","image":"preOnBoarding_image__3kuaq"};